var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2766 12.9423C14.0266 13.1923 13.6874 13.3328 13.3338 13.3328H2.66624C2.31259 13.3328 1.97342 13.1923 1.72336 12.9423C1.47329 12.6923 1.3328 12.3531 1.3328 11.9995V3.33327C1.3328 2.97967 1.47329 2.64054 1.72336 2.39051C1.97342 2.14047 2.31259 2 2.66624 2H5.28645C5.50721 2.00004 5.7245 2.05487 5.91883 2.15959C6.11317 2.26431 6.27846 2.41563 6.39987 2.59997L6.93992 3.39993C7.06257 3.58618 7.22998 3.73868 7.42682 3.8435C7.62367 3.94832 7.84366 4.00209 8.06667 3.99991H13.3338C13.6874 3.99991 14.0266 4.14038 14.2766 4.39041C14.5267 4.64045 14.6672 4.97957 14.6672 5.33318V11.9995C14.6672 12.3531 14.5267 12.6923 14.2766 12.9423Z",
    stroke: "#475569",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.aab361705de3ee9b44e26bdf0275ff95.svg";
export { ForwardRef as ReactComponent };